import type {
  RemoteConfigBannerAudience,
  RemoteConfigBannerColor,
} from 'src/interfaces/remoteConfig'

export enum RemoteConfigKey {
  ContractorPortalBanner = 'contractor_portal_banner',
  ClientBanner = 'client_banner',
}

export const REMOTE_CONFIG_BANNER_COLORS: RemoteConfigBannerColor[] = [
  'info',
  'purple',
  'orange',
  'success',
  'error',
]

export const REMOTE_CONFIG_BANNER_AUDIENCES: RemoteConfigBannerAudience[] = ['all', 'settlement']
